import { render, staticRenderFns } from "./salaryPerformance.vue?vue&type=template&id=1587b3ed"
import script from "./salaryPerformance.vue?vue&type=script&lang=js"
export * from "./salaryPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1587b3ed')) {
      api.createRecord('1587b3ed', component.options)
    } else {
      api.reload('1587b3ed', component.options)
    }
    module.hot.accept("./salaryPerformance.vue?vue&type=template&id=1587b3ed", function () {
      api.rerender('1587b3ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeKanban/components/salaryPerformance.vue"
export default component.exports